
import React from "react";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { ApprovalWorkflowDialogWrapper } from "./SimpleDialogStyled";


const OkayDialog = ({ openDialog, handleOkayClick, title, description,imgsrc }) => {
  const handleButtonOkayClick = () => {
    handleOkayClick();
  };

  return (
    <div>
      <ApprovalWorkflowDialogWrapper
        open={openDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        scroll="paper"
        maxWidth="xs"
        fullWidth={true}
      >
        <DialogTitle id="alert-dialog-title" className="customDialogTitle">
          {title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            className="customDialog"
          >
            <div>
              <img src={imgsrc} alt="img" />
            </div>
            <div className="">{description}</div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialogbutton">
          <Button
            variant="contained"
            className="confirmButton"
            onClick={handleButtonOkayClick}
          >
            Confirm
          </Button>
        </DialogActions>
      </ApprovalWorkflowDialogWrapper>
    </div>
  );
};

export default OkayDialog;
